<template>
  <div class="homepage">
    <div>
      <banner></banner>
      <navigation></navigation>
    </div>
    <div class="hero">
      <div class="container">
        <div v-if="isAfterLaunchDate" class="row info">
          <div :class="[isRegistering ? 'registering' : 'notRegistering', 'col-12 col-md-6']">
            <h1 v-if="isBeforeDeadline">Applications are Open!</h1>
            <h1 v-if="isAfterDeadline">Applications are Closed</h1>
            <h3 v-if="isBeforeDeadline" class="info-content">Team Leader Applications Are Due <br /><strong>{{
                formattedDate(applicationTlEndDate) }}</strong></h3>
            <h3 v-if="isBeforeDeadline" class="info-content">Student Volunteer Applications Are Due <br /><strong>{{
                formattedDate(applicationEndDate) }}</strong></h3>
            <h3 v-if="isAfterDeadline" class="info-content">Acceptances are currently rolling out and will be finalized by the last week of May</h3>
            <h1 v-if="isAfterDeadline" style="margin-top: 10px">Interested in Volunteering at SIGGRAPH 2026?</h1>
            <h3 v-if="isAfterDeadline" class="info-content">Join the <a class="display-link" href="http://eepurl.com/i_uiZY">2026
                SV mailing list.</a></h3>
            <h1 v-if="isAfterSchedulesOut" style="margin-top: 10px">Schedules are out!</h1>
            <h3 v-if="isAfterSchedulesOut" class="info-content">Please <strong>log in</strong> to see your schedule. <br /><br /><small>If
                you worked more than 25 hours on pre-conference shifts you might not have a conference week
                schedule.</small></h3>
            <button v-if="isBeforeDeadline && !isRegistering" @click.prevent="toggleRegister" type="button"
              class="btn arrow-btn-large">
              <div>Start New Application</div>
            </button>
          </div>
          <div class="col-12 col-md-6">
            <login v-bind:isRegistering="isRegistering" @toggle="toggleRegister"></login>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12" style="display: flex; justify-content: center;">
              <h1 style="max-width: fit-content;">Applications will open soon!</h1>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h3> If you would like to be notified when applications are open, join the <a class="display-link"
                  href="https://forms.gle/Q5rjMZUEoqEJnDnc6">2026 SV mailing list.</a></h3>
            </div>
          </div>

          <!-- {{ formattedDate(applicationLaunchDate) }}</h1> -->
        </div>
      </div>
    </div>
    <div class="main-content">
      <!-- TODO: Update sponsors for 2022
      <div class="container mt-4">
        <div class="row">
          <div class="col" style="text-align: center; margin-top: 20px;">
            <h1>Diamond Sponsors</h1>
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 1020px; height: 200px;" src="../assets/sponsors/Diamond_Dreamworks_1020x200.png" alt="Dreamworks"  />
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 1020px; height: 200px;" src="../assets/sponsors/Diamond_Foundry_Logo_1020x200.png" alt="Dreamworks"  />
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 1020px; height: 200px;" src="../assets/sponsors/Diamond_FoxRenderFarm_SponsoredPage.jpg" alt="Dreamworks"  />
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 1020px; height: 200px;" src="../assets/sponsors/Diamond_moho-siggraph_banner02_1020x200px.jpg" alt="Dreamworks"  />
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin-top: 20px;">
            <h1>Gold Sponsors</h1>
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 500px; height: 200px;" src="../assets/sponsors/Gold_500X200_Black_Transparent.png" alt="Dreamworks"  />
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin-top: 20px;">
            <h1>Bronze Sponsors</h1>
          </div>
        </div>
        <div class="row">
          <div class="col" style="text-align: center; margin: 20px;">
            <img style="width: 240; height: 100;" src="../assets/sponsors/Bronze_graphixly-siggraph2021_banner01_240x100px.jpg" alt="Dreamworks"  />
          </div>
        </div>
      </div> -->
      <!-- <div class="container">
        <div id="eligibility" class="row">
          <h2 style="margin-left: 15px;">Eligibility</h2>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <h3>Age</h3>
            <p>Applicants must be 18 years of age or older (on or before 15 May 2026).</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>Full Time Student Status</h3>
            <p>Applicants must be/have been enrolled as a full-time high school, undergraduate, or graduate students for
              at least one semester between June 2024 and September 2026.</p>
          </div>
        </div>
      </div>
      <div class="container">
        <div id="expectations" class="row">
          <h2 style="margin-left: 15px;">Expectations</h2>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <p>Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer
              Program after accepting a position.</p>
            <p>Student Volunteers and Team Leaders will serve the conference in-person shifts (on-site at SIGGRAPH 2026
              in Los Angeles).</p>
            <p>Student Volunteers commit to volunteering about 25 hours to provide operational support for SIGGRAPH 2026
              in pre-conference shifts or the in-person conference. In exchange for their service and enthusiasm,
              Student Volunteers receive the highest level of registration for the conference, networking opportunities,
              and a number of exclusive Student Volunteer-only benefits.</p>
            <p>Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support for
              SIGGRAPH 2026 pre-conference shifts or the in-person conference. In exchange for their service and
              enthusiasm, Team Leaders receive the highest level of registration for the conference, networking
              opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>For In-person Volunteers</h3>
            <ul style="list-style-type:square; padding-left: 15px">
              <li>You are expected to participate in SIGGRAPH 2026 all day from 18 July - 23 July 2026 in Los Angeles.
              </li>
              <li>DO NOT plan to depart the Los Angeles Convention Center earlier than 6PM (GMT-7) on 23 July 2026.
              </li>
              <li>No housing or accommodation will be provided to Team Leaders or Student Volunteers.</li>
              <li>Student Volunteers and Team Leaders can opt for financial assistance on their application form. If you
                are awarded financial aid, you will be emailed in June 2026 regarding the amount and how to process your
                reimbursement.</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <p>More details on what involves being a Student Volunteer will be provided during the upcoming months.</p>
            <p>If you have any questions regarding the program and processes, please email <a
                href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a></p>
          </div>
          <div class="col-md-12 col-sm-12">
            <h3>Attend Mandatory Orientation</h3>
            <p>Student Volunteers and Team Leaders are required to complete training provided by the Student Volunteer
              Program after accepting a position.</p>
          </div>
          <div class="col-md-12 col-sm-12">
            <p><b>IMPORTANT.</b> More details on what involves being a in-person Student Volunteer will be provided upon
              acceptance. We encourage you to visit our <a
                href="https://s2026.siggraph.org/program/student-volunteers/">FAQs</a> section to stay abreast of the
              latest updates regarding the Student Volunteer Program.</p>
          </div>
        </div>
      </div>

      <div class="container">
        <div id="benefits" class="row">
          <h2 style="margin-left: 15px;">Benefits</h2>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <h3>Full conference Registration</h3>
            <p>Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many
              opportunities to explore the latest innovations when you are off-shift.</p>
            <h3>Student Volunteer Special Sessions</h3>
            <p>Hear top professionals in the industry and academia (some of them former Student Volunteers) speak about
              tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before SIGGRAPH 2026!
            </p>
            <h3>S3 Résumé and Reel Review Sessions</h3>
            <p>Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land your
              dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services Committee
              (S3).</p>
            <h3>Professional Development</h3>
            <p>Expand your knowledge outside the classroom through leadership, mentoring, and diversity & inclusion
              sessions tailored specially for student volunteers.</p>
            <h3>Networking</h3>
            <p>Participate in the many events and get-togethers we will organize prior to and during the conference.
              Meet students from all over the globe who share your passion for computer graphics and interactive
              techniques!</p>
          </div>
        </div>
      </div>
      <div class="container">
        <div id="deadlines" class="row">
          <h2 style="margin-left: 15px;">Deadlines</h2>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <p>Please comply with the submission deadlines and ensure you submit your application by the appropriate day
              and time. We will not accept any late applications or make any exceptions for students due to
              miscalculation of the application deadline. Thank you for your understanding.</p>
            <p>Please adjust your spam filter so messages with the ‘siggraph.org’ domain will not be placed in your
              junk-mail folder.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>{{ formattedDate(applicationTlEndDate) }}:</strong> Team Leader Applications Deadline</h3>
            <p>Only open to students who have previously served as Student Volunteers. Please complete the regular
              Student Volunteer application and the Team Leader essays on the application by 22:00 UTC/GMT.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>Early-February 2026:</strong> Team Leader Acceptance Notification</h3>
            <p>Team Leader application results will be sent in early-February 2026. You will receive an email notification
              at the address you provided in your application. Applicants who are not accepted as Team Leaders will
              still be considered for Student Volunteer positions.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>{{ formattedDate(applicationEndDate) }}:</strong> Student Volunteer Application Deadline</h3>
            <p>The Student Volunteer application must be completed by 22:00 UTC/GMT (convert to your time zone). Please
              note you will be required to upload proof of full-time student status (e.g., transcript, proof of
              enrollment, etc.). We recommend you allow ample time to gather this information from your institution
              before the due date. Without this documentation, your application will be marked as incomplete.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3><strong>Late April 2026:</strong> Student Volunteer Acceptance Notification</h3>
            <p>Student Volunteer application results will be sent in late April 2026. You will receive an email
              notification at the address you provided in your application.</p>
          </div>
        </div>
      </div> -->
      <div class="container">
        <div class="row last">
          <div class="col">
            <h2>Questions? Contact Us!</h2>
            <p>Our <a href="https://s2026.siggraph.org/student-volunteers-submissions-faq/">FAQ</a> is a helpful
              resource designed to keep you informed about general requirements, program details, deadlines,
              and the SIGGRAPH student volunteer experience! You can find the latest updates and information
              about the Student Volunteer Program on the conference website <a
                href="https://s2026.siggraph.org/program/student-volunteers/">here</a>.</p>
            <p>If you have additional questions or concerns that aren't found on these pages, please reach out to us via
              email at <a href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>, and a team member will follow
              up with you!</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Nav'
import Footer from '@/components/Footer'
import Countdown from './Countdown'
import Login from '@/components/user/Login'
import Banner from '@/components/Banner'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'Home',
  components: {
    Navigation,
    Countdown,
    Login,
    Footer,
    banner: Banner
  },
  data () {
    return {
      isRegistering: false
    }
  },
  methods: {
    toggleRegister: function () {
      this.isRegistering = !this.isRegistering
      window.scrollTo(0, 0)
    },
    formattedDate: function (date) {
      // This change is from 2025 feedback to show times with the date, choosing local timezone of the conference
      return moment(date).tz('America/Los_Angeles').format('D MMMM YYYY HH:mm z')
    }
  },
  computed: {
    ...mapState(['applicationLaunchDate', 'applicationTlEndDate', 'applicationEndDate', 'acceptanceDate']),
    ...mapGetters(['isAfterLaunchDate', 'isBeforeDeadline', 'isAfterDeadline', 'isAfterSchedulesOut'])
  }
}
</script>

<style lang="scss">
  @import '~@fortawesome/fontawesome-free/css/all.css';
</style>



// WEBPACK FOOTER //
// src/components/Home.vue